<div class="container-fluid top-nav pt-3">
  <!---JUST FOR TESTING THE PORTAL COMPONENTS ARE SHOWN HERE
        <app-customerportal-help></app-customerportal-help>-->
  <div class="row">
    <div class="col">
      <app-customerwelcome [quill]="true"></app-customerwelcome>
      <!-- <div class="card mb-3">
              <div class="card-body">
                <p>2</p>
              </div>
            </div> -->
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col">
          <h6 class="pl-3">{{ 'customerportalcontrol.projects' | trans }}</h6>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <p class="pl-3">{{ 'customerportalcontrol.projectslisted' | trans }}</p>
        </div>
      </div>
    </div>
    <div class="col">
      <button data-toggle="modal" data-target="#filelistModal" class="border-0 bg-transparent float-right">
        <span class="material-icons portal-icon align-middle lh-35 center btn p-0 rounded-circle mt-2 w-35 h-35">
          cloud_circle
        </span>
      </button>
    </div>


  </div>

  <app-projectslist></app-projectslist>
</div>

<div class="spacer"></div>
<!-- Modal filelist -->
<div class="modal fade" id="filelistModal" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">{{ 'customerportalcontrol.files' | trans }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span>&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <app-filelist [modal]="true" [list]="true" [filetype]="'customer'"
          [entityid]="customer.customerId"></app-filelist>
      </div>
    </div>
  </div>
</div>